'use strict';
const angular = require('angular');
const {extend, isDefined, isObject} = angular;

module.exports = [
  '$provide',
  $modalDecorator];

// TODO: implement standard API in front of ionic service
function $modalDecorator($provide) {
  $provide.decorator('$modal', [
    '$delegate',
    '$exceptionHandler',
    '$window',
    '$document',
    '$controller',
    '$rootScope',
    '$ionicModal',
    'DeviceServices',
    decorateService]);

  function decorateService($delegate, $exceptionHandler, $window, $document, $controller, $rootScope, $ionicModal, DeviceServices) {
    var defaultOptions = {
      animation: 'slide-in-up',
      focusFirstInput: !$window.ionic.Platform.isWebView(),
      backdropClickToClose: true,
      hardwareBackButtonClose: true,
      modalCallback: null
    };

    $delegate.show = showLegacy;
    $delegate.showModal = show;

    function showLegacy(options) {
      return show(options).result;
    }

    function show(options) {
      if (!isObject(options)) return _rejectShow(new Error('$modal.show called with invalid arguments. You must specify an options object.'));
      try {
        const deferred = Promise.defer();
        const response = {
          result: deferred.promise,
        };

        const ionicOptions = {
          scope: options.scope,
          animation: isDefined(options.animation) ? options.animation : defaultOptions.animation,
          focusFirstInput: isDefined(options.focusFirstInput) ? options.focusFirstInput : defaultOptions.focusFirstInput,
          backdropClickToClose: isDefined(options.clickOutsideToClose) ? options.clickOutsideToClose : defaultOptions.backdropClickToClose,
          hardwareBackButtonClose: isDefined(options.escapeToClose) ? options.escapeToClose : defaultOptions.hardwareBackButtonClose,
          modalCallback: options.modalCallback
        };

        options.hardwareBackButtonClose = ionicOptions.hardwareBackButtonClose;

        if (options.templateUrl) {
          response.modal = $ionicModal.fromTemplateUrl(options.templateUrl, ionicOptions).then(function (modal) {
            _initializeDialog(modal, options, deferred);
            return modal;
          });
        } else if (options.template) {
          const modal = $ionicModal.fromTemplate(options.template, ionicOptions);
          _initializeDialog(modal, options, deferred);
          response.modal = Promise.resolve(modal);
        } else {
          return _rejectShow(new Error('$modal.show: Creating modal without a template specified!'));
        }

        return response;
      } catch (error) {
        $exceptionHandler(error, options);
        return _rejectShow(error);
      }
    }

    function _rejectShow(error) {
      const errorPromise = Promise.reject(error);
      return {
        modal: errorPromise,
        result: errorPromise,
      };
    }

    function _initializeDialog(modal, options, deferred) {
      try {

        Object.defineProperty(modal, '$$deferred', {value: deferred});
        Object.defineProperty(modal, '$$isResolved', {writable: true, value: false});

        var locals = extend({}, options.locals, {$scope: modal.scope});

        if (options.hardwareBackButtonClose) {
          $document[0].addEventListener('keydown', __handleKeyPress);
        }

        locals.$modal = {
          hide: function (result) {
            modal.$$isResolved = true;
            return modal.hide(result).then(function () {
              modal.$$deferred.resolve(result);
              return result;
            });
          },
          cancel: function __hideModal(reason) {
            modal.$$isResolved = true;
            return modal.hide(reason).then(function () {
              modal.$$deferred.reject(reason);
              return reason;
            });
          }
        };

        $delegate.register(modal);

        var unwatchCleanup = modal.scope.$on('modal.hidden', __cleanup);

        var controller = $controller(options.controller || DefaultModalController, locals);

        if (options.controllerAs) {
          modal.scope[options.controllerAs] = controller;
          controller.hide = modal.scope.hide;
          controller.cancel = modal.scope.cancel;
        }

        var stateWatcher = $rootScope.$on('$stateChangeStart', function () {
          try {
            locals.$modal.cancel();
          } catch (e) {
            console.warn(e)
          }
        });

        modal.show();
      } catch (e) {
        deferred.reject(e);
      }

      function __handleKeyPress(event) {
        if (event.keyCode == 27) {
          //console.log('close modal by esc key', event);
          $delegate.closeLastOpened();
        }
      }

      function __cleanup($event, $modal) {
        // Make sure to clean up the current dialog only if the event was fired by this dialog
        if ($modal !== modal) return;
        //console.log('cleaning up modal', modal);

        if (unwatchCleanup) {
          unwatchCleanup();
          unwatchCleanup = null;
        }

        $delegate.deregister(modal);

        if (!modal.$$isResolved == true) modal.$$deferred.reject(null);
        modal.remove();

        $document[0].removeEventListener('keydown', __handleKeyPress);

        if (DeviceServices.isWebView()) {
          $window.cordova.plugins.Keyboard.close();
        }

        if (stateWatcher) {
          stateWatcher();
        }
      }
    }

    return $delegate;
  }
}


function DefaultModalController() {
}


// WEBPACK FOOTER //
// ./src/js/core-components-implementation/modals/ModalServiceIonic.js